import { IIsiUIFlowResult } from "./Isilog/Core/IIsiUIFlowResult";
import { IsiPlPerformanceAnalyser } from "./Isilog/PresentationLogic/IsiPlPerformanceAnalyser";


export class IsiPerformance {

    public constructor() { }

    protected pageStartingTime: number = new Date().getTime();
    protected pageOnloadEndTime;

    /**
     * Cette fonction permet de demarrer ou de stopper une mesure
     * @param obj
     */
    protected _managePerformanceMesure(obj): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            if (obj) {
                switch (obj.getAttribute("key")) {
                    case "stop":
                        this._stopPerformanceMesure(obj).then((stopResult: IIsiUIFlowResult) => {
                            resolve(stopResult);
                        }).catch((ex) => {
                            reject(ex);
                        });
                        break;
                    case "reset":
                        this._resetPerformanceMesure().then((resetResult: IIsiUIFlowResult) => {
                            resolve(resetResult);
                        }).catch((ex) => {
                            reject(ex);
                        });
                        break;
                    default:
                        this._startPerformanceMesure(obj).then((startResult: IIsiUIFlowResult) => {
                            resolve(startResult);
                        }).catch((ex) => {
                            reject(ex);
                        });
                        break;
                }
            } else {
                resolve({ result: true, continue: true });
            }
        });
    }

    /**
     * Arrêt d'une mesure de performances
     * @param obj
     */
    private _stopPerformanceMesure(obj): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            const plPerformanceAnalyser = new IsiPlPerformanceAnalyser();
            const startTooltip = uiCore.getMessage("Benchmark", "TraceStart").IsiLabel;

            obj.setAttribute("key", "start");
            obj.setAttribute("isititle", startTooltip); //On change le tooltip en Start

            // Arrête de la mesure
            plPerformanceAnalyser.StopPerformanceMesure().then((flow: IIsiUIFlowResult) => {
                resolve(flow);
            }).catch((ex) => {
                reject(ex);
            });
        });
    }

    /**
    * Reset d'une mesure de performances
    */
    private _resetPerformanceMesure(): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            const plPerformanceAnalyser = new IsiPlPerformanceAnalyser();

            // Reset de la mesure
            plPerformanceAnalyser.ResetPerformanceMesure().then((flow: IIsiUIFlowResult) => {
                resolve(flow);
            }).catch((ex) => {
                reject(ex);
            });
        });
    }

    /**
    * Lancement d'une mesure de performances
    * @param obj
    */
    private _startPerformanceMesure(obj): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            const plPerformanceAnalyser = new IsiPlPerformanceAnalyser();
            const stopTooltip = uiCore.getMessage("Benchmark", "TraceStop").IsiLabel;

            obj.setAttribute("key", "stop");
            obj.setAttribute("isititle", stopTooltip); //On change le tooltip en Stop

            // Lancement de la mesure
            plPerformanceAnalyser.StartPerformanceMesure().then((flow: IIsiUIFlowResult) => {
                resolve(flow);
            }).catch((ex) => {
                reject(ex);
            });
        });
    }

    /**
     * Méthode d'écriture des logs à la fin du chargement
     * */
    protected _writeLogOnLoadEnd(pagePageEndTime: number): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            this.pageOnloadEndTime = new Date().getTime();
            let pageEndStartTime;
            let pageOnloadEndStartTime;

            if ((this.pageStartingTime) && (pagePageEndTime) && (this.pageOnloadEndTime)) {
                // Calcul des durées à fournir au traitement
                pageEndStartTime = pagePageEndTime - this.pageStartingTime;
                pageOnloadEndStartTime = this.pageOnloadEndTime - pagePageEndTime;

                // Appel à l'analyseur de performances client
                const plPerformanceAnalyser = new IsiPlPerformanceAnalyser();
                plPerformanceAnalyser.PerformanceAnalyserClient(isiApp.screen.name, pageEndStartTime, pageOnloadEndStartTime).then((flow: IIsiUIFlowResult) => {
                    resolve(flow);
                }).catch((ex) => {
                    reject(ex);
                });
            } else {
                resolve({ result: true, continue: true });
            }
        });
    }
}
